import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Stack from "@mui/material/Stack";
import dayjs from "dayjs";
import TextFieldDate from "../../UI/TextFieldDate";

const isValida = (data) => data && dayjs(data).isValid();

/** Diálogo de cadastro/edição de um período (Cronograma Data). */
export default function CronogramaDataForm({ cronogramaData, onClose, onSave, loadingSave }) {
  const [valores, setValores] = useState({ dataInicio: null, dataFim: null });

  useEffect(() => {
    if (!cronogramaData) return;
    setValores({
      dataInicio: cronogramaData.dataInicio ?? null,
      dataFim: cronogramaData.dataFim ?? null,
    });
  }, [cronogramaData]);

  const fimAntesDoInicio =
    isValida(valores.dataInicio) &&
    isValida(valores.dataFim) &&
    dayjs(valores.dataFim).isBefore(dayjs(valores.dataInicio), "day");
  const podeSalvar = isValida(valores.dataInicio) && !fimAntesDoInicio && !loadingSave;

  const handleChange = (campo) => (value) =>
    setValores((prevState) => ({ ...prevState, [campo]: value ? dayjs(value) : null }));

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!podeSalvar) return;
    onSave({ ...cronogramaData, ...valores });
  };

  return (
    <Dialog open={Boolean(cronogramaData)} onClose={onClose} fullWidth maxWidth="xs">
      <form onSubmit={handleSubmit}>
        <DialogTitle>{cronogramaData?.codigo ? "Editar Período" : "Novo Período"}</DialogTitle>
        <DialogContent>
          <Stack spacing={2} pt={1}>
            <TextFieldDate
              label="Data Início"
              value={valores.dataInicio}
              onChange={handleChange("dataInicio")}
              slotProps={{ textField: { size: "small", fullWidth: true, required: true } }}
            />
            <TextFieldDate
              label="Data Fim"
              value={valores.dataFim}
              onChange={handleChange("dataFim")}
              slotProps={{
                textField: {
                  size: "small",
                  fullWidth: true,
                  error: fimAntesDoInicio,
                  helperText: fimAntesDoInicio ? "Não pode ser anterior à data início." : "Opcional.",
                },
              }}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancelar</Button>
          <Button type="submit" variant="contained" disabled={!podeSalvar}>
            Salvar
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
